import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import DailyRepaymentUI from './DailyRepaymentUI.js'

class DailyRepaymentSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      successMsg: null,
      checked: this.props.loan.disbursement.dailyRepayment,
      submitted: false,
    }
  }

  render() {
    return (
      <DailyRepaymentUI
        context={this.props.context}
        checked={this.state.checked}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        submitted={this.state.submitted}
        onSubmit={this.onSubmit}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      checked: !this.state.checked,
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/test/loans/${this.props.match.params.loanId}/repayments/daily`,
      this.onSubmitCallback, {
        dailyRepayment: !this.state.checked
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (this.state.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.Loan(this.props.match.params.loanId))
      setTimeout(() => {
        this.setState({successMsg: null})
      }, 2000);
    }
  }
}

export default withRouter(DailyRepaymentSF)
